import { lazy } from "react";

import Login from "../pages/login";

export const routes = [
    {
        path: "/",
        Component: Login
    },
    {
        path: "/login",
        Component: Login
    },
    {
        path: "/logout",
        Component: lazy(() => import("../pages/logout"))
    },
    {
        path: "/featured-list/:status?",
        Component: lazy(() => import("../pages/featured-list"))
    },
    {
        path: "/anime-lists",
        Component: lazy(() => import("../pages/anime-lists/overview"))
    },
    {
        path: ":username/anime-lists/shared/:slug/:status?",
        Component: lazy(() => import("../pages/anime-lists/shared"))
    },
    {
        path: "/anime-lists/:slug/:status?",
        Component: lazy(() => import("../pages/anime-lists/detail"))
    },
    {
        path: "/anime-lists/import/mal",
        Component: lazy(() => import("../pages/anime-lists/import-mal"))
    },
    {
        path: "/featured-list/calendar",
        Component: lazy(() => import("../pages/calendar"))
    },
    {
        path: "/anime-lists/:slug/calendar",
        Component: lazy(() => import("../pages/calendar"))
    },
    {
        path: "search",
        Component: lazy(() => import("../pages/search"))
    },
    {
        path: "seasons",
        Component: lazy(() => import("../pages/seasons"))
    },
    {
        path: "profile",
        Component: lazy(() => import("../pages/profile"))
    },
    {
        path: "genres",
        Component: lazy(() => import("../pages/genres/overview"))
    },
    {
        path: "users",
        Component: lazy(() => import("../pages/users/overview"))
    },
    {
        path: "users/new",
        Component: lazy(() => import("../pages/users/new"))
    },
    {
        path: "users/invite/:code/complete",
        Component: lazy(() => import("../pages/users/complete-invite"))
    },
    {
        path: "search/listed-anime",
        Component: lazy(() => import("../pages/searchListedAnime"))
    },
    {
        path: "api",
        Component: lazy(() => import("../pages/api"))
    },
    {
        path: "feedback",
        Component: lazy(() => import("../pages/feedback/overview"))
    },
    {
        path: "feedback/send",
        Component: lazy(() => import("../pages/feedback/send"))
    }
]
